
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/[projectId]/edit",
      function () {
        return require("private-next-pages/projects/[projectId]/edit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/[projectId]/edit"])
      });
    }
  